/**
 * LoadingFallback - Vises mens lazy-loadede sider lastes
 *
 * Brukes som fallback i React.Suspense for code splitting.
 * Se App.tsx for hvordan dette brukes med React.lazy().
 */
import { Loader2 } from 'lucide-react';

export const LoadingFallback: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <Loader2 className="h-8 w-8 animate-spin text-variant-magenta" aria-hidden="true" />
    <span className="sr-only">Laster inn...</span>
  </div>
);
